import {toast} from "react-toastify";


export const getFile = (token, orderContractId, fileId, url, fileName, fileType) => {
  let newUrl = url.split('://');
  let urlTab = url?.split('/');
  newUrl[1] = newUrl[1].replace('\/\/', '\/');
  return fetch(
    newUrl.join('://'),
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(res => res.blob())
    .then(data => {
      const blob = new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || urlTab?.[urlTab.length - 1]);  // 3. Append to html page
      document.body.appendChild(link);  // 4. Force download
      link.click();  // 5. Clean up and remove the link
      link.parentNode.removeChild(link);
    })
    .catch(error => {
      toast.error(`Nie udało się pobrać pliku`)
    });
  // return axios({
  //   method: 'GET',
  //   url: newUrl.join('://'),//`${BASE_URL_API}/v1/company-panel/order-contracts/${orderContractId}/download-pdf`,
  //   config: {
  //     responseType: 'blob'
  //   }
  // }).then(({data})=>{
  //   const blob = new Blob([data], {type:fileType, endings: 'native'});
  //   const url = window.URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', fileName);  // 3. Append to html page
  //   document.body.appendChild(link);  // 4. Force download
  //   link.click();  // 5. Clean up and remove the link
  //   link.parentNode.removeChild(link);
  // });
}
